export default __webpack_public_path__ + "static/media/Poppins-Regular.020ca972.ttf";